import { v4 as uuidv4 } from 'uuid';
import { get, sumBy } from 'lodash';
// import moment from 'moment';

import {
  TOGGLE_MODAL_ADD_NEW_CUSTOMER,
  SET_CURRENT_ORDER,
  FETCH_POS_ORDER_DETAIL_SUCCESS,
  ADD_ORDER_ITEM,
  UPDATE_ORDER_ITEM,
  REMOVE_ORDER_ITEM,
  UPDATE_ORDER_ITEM_NOTE,
  HIDE_ALL_ORDER_ITEM_NOTE,
  UPDATE_CURRENT_ORDER_NOTE,
  REMOVE_CURRENT_ORDER,
  ADD_CURRENT_CUSTOMER,
  REMOVE_CURRENT_CUSTOMER,
  TOGGLE_CUSTOMER_MODAL,
  UPDATE_ORDER_DISCOUNT,
  CHANGE_ORDER_DISCOUNT_TYPE,
  UPDATE_ORDER_SUMMARY,
  POS_SET_LOADING,
  CHANGE_ORDER_TYPE,
  SET_LOADING_PAGE,
  SET_PARKED_ORDERS,
  ADD_PARKED_ORDER_TO_CURRENT_ORDER,
  CHECKOUT_SUCCESS,
  SHOW_POS_ORDER,
  POS_CHECKOUT,
  POS_PRINT,
  CHANGE_TOTAL_PAID,
  TOGGLE_RETURN_ORDER_MODAL,
  ADD_RETURN_ORDER_TO_CURRENT_ORDER,
  SET_POS_LAYOUT,
  SET_CURRENT_POS_CATEGORY,
  SET_SEARCH_RESULTS,
  TOGGLE_MEDICAL_FORM,
  ADD_CURRENT_DOCTOR,
  UPDATE_CURRENT_DOCTOR,
  CONTINUE_SELL,
  SET_CURRENT_FOLDER,
  ADD_PRESCRIPTION_TO_CURRENT_ORDER,
  UPDATE_PRESCRIPTION,
  ADD_PRESCRIPTION_TEMPLATE_TO_CURRENT_ORDER,
  UPDATE_POS_RESULTS_STATUS,
  UPDATE_ALL_POS_LAYOUT_ITEMS_STATUS,
  ADD_PRINT_ORDER,
  REMOVE_PRINT_ORDER,
  REMOVE_PARKED_ORDER,
} from 'constants/ActionTypes';
import { POS_DISCOUNT_TYPE, POS_ORDER_TYPE, PRODUCT_TRACKING_TYPE } from 'constants/Common';

export function PosReducer(draft, action) {
  const { type, payload } = action;
  switch (type) {
    case TOGGLE_MODAL_ADD_NEW_CUSTOMER:
      draft.showAddNewCustomerModal = !draft.showAddNewCustomerModal;
      return;
    // Should use this event. It does not use anywhere.
    case SET_CURRENT_ORDER:
      draft.currentOrder = {
        ...payload,
      };
      return;
    case FETCH_POS_ORDER_DETAIL_SUCCESS: {
      draft.currentOrder = payload.posOrder;
      draft.orderItems = payload.items;
      return;
    }
    case TOGGLE_MEDICAL_FORM: {
      draft.isVisibleMedicalForm = !draft.isVisibleMedicalForm;
      return;
    }
    case ADD_ORDER_ITEM: {
      // TODO: Check item inventory.
      // TODO: Check expired.
      const product = payload;
      const index = draft.orderItems.findIndex(item => item.product_id === product.id && !item.is_return);
      if (index !== -1) {
        if (product.quantity) {
          draft.orderItems[index].quantity += product.quantity;
        } else {
          draft.orderItems[index].quantity++;
        }
      } else {
        let outOfStock = false;
        const quantityAvailable = product?.qty_available;
        if (!product?.is_return && product?.tracking_type !== PRODUCT_TRACKING_TYPE.TRACKING_TYPE_NONE) {
          outOfStock = quantityAvailable <= 0;
        }
        // if (product?.lots && product?.lots.length > 0) {
        //   const lot = product.lots[0];
        //   const isExpire = moment().format('YYYY-MM-DD') > lot.expiry_date;
        //   const out = lot.product_qty <= 0;
        //   if (isExpire || out) {
        //     outOfStock = true;
        //   }
        // }
        draft.orderItems.push({
          ...product,
          id: product?.id || uuidv4(),
          name: product.name,
          product_id: product?.product_id,
          quantity: product?.quantity ? product.quantity : 1,
          price: product?.price,
          note: {
            status: false,
            text: product?.note?.text ?? '',
          },
          quantityAvailable,
          lots: !product?.is_return ? product?.lots?.reverse() : product?.lots,
          is_return: product?.is_return ?? false,
          uom: product.uom,
          outOfStock,
          notExists: !product?.product_id,
        });
      }

      return;
    }
    case UPDATE_ORDER_ITEM: {
      const {
        field,
        value,
        product: { product_id, is_return },
      } = payload;
      const index = draft.orderItems.findIndex(item => product_id === item.product_id && is_return === item.is_return);
      if (index !== -1) {
        draft.orderItems[index][field] = value;
      }
      return;
    }
    case REMOVE_ORDER_ITEM: {
      const removedItem = payload;
      const index = draft.orderItems.findIndex(item => {
        if (!item?.is_return) {
          return removedItem.product_id === item.product_id;
        }
        return removedItem.id === item.id;
      });
      if (index !== -1) {
        if (removedItem.is_return) {
          draft.orderItems.splice(index, 1, {
            ...draft.orderItems[index],
            quantity: 0,
          });
        } else {
          draft.orderItems.splice(index, 1);
        }
      }
      draft.posLayout.categories = draft.posLayout.categories?.map(category => {
        return {
          ...category,
          items: category?.items.map(item => {
            if (item?.product?.id === removedItem?.product_id) {
              return {
                ...item,
                has_in_cart: false,
              };
            }
            if (item?.folder) {
              const newFolderItems = item?.folder?.items?.map(folderItem => {
                if (folderItem?.product?.id === removedItem?.product_id) {
                  return {
                    ...folderItem,
                    has_in_cart: false,
                  };
                }
                return folderItem;
              });
              return {
                ...item,
                folder: {
                  ...item?.folder,
                  items: newFolderItems,
                },
              };
            }
            return item;
          }),
        };
      });
      return;
    }
    case UPDATE_ORDER_ITEM_NOTE: {
      const { note, index } = payload;
      if (index !== -1) {
        draft.orderItems[index].note = note;
      }
      return;
    }
    case HIDE_ALL_ORDER_ITEM_NOTE: {
      draft.orderItems = draft.orderItems.map(item => ({
        ...item,
        note: {
          ...item.note,
          status: false,
        },
      }));
      return;
    }
    case SET_SEARCH_RESULTS:
      draft.searchResults = payload;
      return;
    case SET_LOADING_PAGE:
      draft.loadingFull = payload;
      return;
    case ADD_CURRENT_DOCTOR:
      draft.currentDoctor = payload;
      return;
    case UPDATE_CURRENT_DOCTOR:
      //  ? Duplicated.
      draft.currentDoctor = payload;
      return;
    case UPDATE_CURRENT_ORDER_NOTE:
      return void (draft.currentOrder.note = payload);
    case REMOVE_CURRENT_ORDER: {
      draft.currentOrder = {
        id: null,
        code: '',
        dateOrder: '',
        type: POS_ORDER_TYPE.SALE,
        status: null,
        note: '',
        discountType: POS_DISCOUNT_TYPE.PERCENT,
        discountPercent: 0,
        discountAmount: 0,
        subtotal: 0,
        grandTotal: 0,
        totalPaid: 0,
        totalReturn: 0,
        soldBy: '',
      };
      draft.orderItems = [];
      draft.currentCustomer = {};
      draft.currentDoctor = {};
      draft.currentPrescription = {};
      return;
    }
    case ADD_CURRENT_CUSTOMER:
      return void (draft.currentCustomer = payload);
    case REMOVE_CURRENT_CUSTOMER:
      return void (draft.currentCustomer = {});
    case TOGGLE_CUSTOMER_MODAL:
      return void (draft.showCustomerModal = payload);
    case UPDATE_ORDER_DISCOUNT: {
      let amount = 0;
      let percent = 0;
      const { currentOrder } = draft;
      const value = payload ?? 0;
      const { subtotal } = draft.currentOrder;
      if (draft.currentOrder.discountType === 'percent') {
        percent = value;
        amount = (subtotal * value) / 100;
      } else if (currentOrder.type === 'return' || currentOrder.type === 'exchange') {
        percent = currentOrder.discountPercent;
        amount = Number((subtotal * percent) / 100);
      } else {
        percent = (value / draft.currentOrder.subtotal) * 100;
        amount = value;
      }
      draft.currentOrder.discountPercent = percent;
      draft.currentOrder.discountAmount = amount;
      draft.currentOrder.grandTotal = subtotal - amount;
      return;
    }
    case CHANGE_ORDER_DISCOUNT_TYPE: {
      draft.currentOrder.discountType = payload;
      draft.currentOrder.discountPercent = 0;
      draft.currentOrder.discountAmount = 0;
      draft.currentOrder.grandTotal = draft.currentOrder.subtotal;
      return;
    }
    case UPDATE_ORDER_SUMMARY: {
      const subtotal = sumBy(
        draft.orderItems.filter(orderItem => !orderItem.notExists),
        item => get(item, 'quantity', 1) * get(item, 'price', 1)
      );
      draft.currentOrder.subtotal = subtotal;
      draft.currentOrder.grandTotal = subtotal - draft.currentOrder.discountAmount;
      draft.currentOrder.totalReturn = draft.currentOrder.grandTotal;
      return;
    }
    case POS_SET_LOADING: {
      draft.loading = payload;
      return;
    }
    case CHANGE_ORDER_TYPE: {
      const { currentOrder } = draft;
      if (currentOrder.type === 'return' || currentOrder.type === 'exchange') {
        const totalNewItem = draft.orderItems.filter(item => !item.is_return).length;
        if (totalNewItem > 0) {
          draft.currentOrder.type = 'exchange';
        } else {
          draft.currentOrder.type = 'return';
        }
      }
      return;
    }
    case SET_PARKED_ORDERS: {
      return void (draft.parkedOrders = payload);
    }
    case CONTINUE_SELL: {
      const index = draft.orderItems.findIndex(item => item.product_id === payload);
      if (index !== -1) {
        draft.orderItems[index].outOfStock = false;
      }
      return;
    }
    case ADD_PARKED_ORDER_TO_CURRENT_ORDER: {
      // Remove parked orders
      const parkedOrder = payload;
      const currentOrder = {
        id: parkedOrder.id,
        code: parkedOrder.code,
        type: parkedOrder.type,
        status: parkedOrder.status,
        note: parkedOrder.note,
        discountType: parkedOrder.discount_type,
        discountPercent: parkedOrder.discount_percent,
        discountAmount: parkedOrder.discount_amount,
        subtotal: parkedOrder.subtotal,
        grandTotal: parkedOrder.grand_total,
        soldBy: parkedOrder.sold_by,
        totalPaid: 0,
        totalReturn: parkedOrder.grand_total,
        returnFor: parkedOrder?.return_for,
      };
      // Add to current orders
      draft.currentOrder = currentOrder;
      // Order Items
      // draft.orderItems = parkedOrder.order_items.map(item => ({
      //   id: item?.id,
      //   name: item.product_name,
      //   product_id: item.product_id,
      //   prescription_item_id: item?.prescription_item_id,
      //   quantity: item.product_qty,
      //   current_quantity: item.product_qty,
      //   price: item.price,
      //   note: {
      //     status: false,
      //     text: item?.note ?? '',
      //   },
      //   uom: {
      //     name: item.uom_name,
      //   },
      //   lots: item.lots,
      //   is_return: item.is_return ? item.is_return : false,
      //   notExists: !item?.product_id,
      // }));
      // Update current prescription
      if (parkedOrder?.prescription) {
        draft.currentPrescription = {
          ...parkedOrder.prescription,
          canEdit: parkedOrder?.prescription && parkedOrder?.prescription?.source === 'offline',
        };
      }
      // Update current customer
      if (parkedOrder?.customer) {
        draft.currentCustomer = {
          ...parkedOrder.customer,
          canEdit: true,
          canDelete: !parkedOrder?.prescription,
        };
      }
      // Update current doctor
      if (parkedOrder?.doctor) {
        draft.currentDoctor = {
          ...parkedOrder.doctor,
          canEdit: true,
          canDelete: !parkedOrder?.prescription,
        };
      }
      return;
    }
    case REMOVE_PARKED_ORDER: {
      const index = draft.parkedOrders.findIndex(parkedOrder => parkedOrder.id === payload);
      if (index !== -1) draft.parkedOrders.splice(index, 1);
      return;
    }
    case ADD_PRINT_ORDER: {
      return void (draft.printOrder = payload);
    }
    case REMOVE_PRINT_ORDER: {
      return void (draft.printOrder = {});
    }
    case CHECKOUT_SUCCESS: {
      const posOrder = payload;
      const orderItems = payload.order_items;
      draft.currentOrder = {
        id: posOrder.id,
        code: posOrder.code,
        type: posOrder.type,
        status: posOrder.status,
        note: posOrder.note,
        discountType: posOrder.discount_type,
        discountPercent: posOrder.discount_percent,
        discountAmount: posOrder.discount_amount,
        subtotal: posOrder.subtotal,
        grandTotal: posOrder.grand_total,
        soldBy: posOrder.sold_by,
        totalPaid: posOrder.total_paid,
      };
      draft.orderItems = orderItems.map(item => ({
        id: item.id,
        name: item.product_name,
        product_id: item.product_id,
        quantity: item.product_qty,
        price: item.price,
        note: {
          status: false,
          text: item.note,
        },
        lots: item?.item_lots ?? [],
        is_return: item.is_return,
      }));
      return;
    }
    case SHOW_POS_ORDER:
      return void (draft.step = 'pos');
    case POS_CHECKOUT:
      return void (draft.step = 'checkout');
    case POS_PRINT:
      return void (draft.step = 'print');
    case CHANGE_TOTAL_PAID: {
      draft.currentOrder.totalPaid = Number(payload);
      draft.currentOrder.totalReturn = Number(payload) - draft.currentOrder.grandTotal;
      return;
    }
    case TOGGLE_RETURN_ORDER_MODAL:
      return void (draft.showReturnOrderModal = payload);
    case ADD_RETURN_ORDER_TO_CURRENT_ORDER: {
      const posOrder = payload;
      // const orderItems = payload.order_items;
      draft.currentOrder = {
        id: null,
        code: posOrder.code,
        type: 'return',
        status: posOrder.status,
        note: posOrder.note,
        discountType: posOrder.discount_type,
        discountPercent: posOrder.discount_percent,
        discountAmount: posOrder.discount_amount,
        subtotal: -posOrder.subtotal,
        grandTotal: -posOrder.grand_total,
        soldBy: posOrder.sold_by,
        totalPaid: 0,
        totalReturn: posOrder.grand_total,
        returnFor: posOrder.id,
      };
      // draft.orderItems = orderItems.map(item => ({
      //   id: item.id,
      //   name: item.product_name,
      //   product_id: item.product_id,
      //   prescription_item_id: item?.prescription_item_id,
      //   quantity: -item.product_qty,
      //   current_quantity: -item.product_qty,
      //   price: item.price,
      //   note: {
      //     status: false,
      //     text: item.note,
      //   },
      //   is_return: true,
      //   notExists: !item?.product_id,
      // }));
      // Update current prescription
      if (posOrder?.prescription) {
        draft.currentPrescription = posOrder.prescription;
      }
      // Update current customer
      if (posOrder?.customer) {
        draft.currentCustomer = {
          ...posOrder.customer,
          canEdit: true,
          canDelete: !posOrder?.prescription,
        };
      }
      // Update current doctor
      if (posOrder?.doctor) {
        draft.currentDoctor = {
          ...posOrder.doctor,
          canEdit: true,
          canDelete: !posOrder?.prescription,
        };
      }
      return;
    }
    case ADD_PRESCRIPTION_TO_CURRENT_ORDER:
      draft.currentOrder.note = payload?.prescription?.instructions || 'Test';
      // draft.orderItems = payload?.prescriptionItems?.map(item => {
      //   return {
      //     id: uuidv4(),
      //     name: item.name,
      //     product_id: item?.product_id,
      //     prescription_item_code: item?.code,
      //     quantity: item.qty,
      //     price: item?.product?.price || 0,
      //     note: {
      //       status: false,
      //       text: item?.usage,
      //     },
      //     is_return: false,
      //     uom: {
      //       name: item.uom_name,
      //     },
      //     // ? Why check out of stock here.
      //     // outOfStock: !item?.product_id,
      //     notExists: !item?.product_id,
      //   };
      // });
      draft.currentPrescription = payload;
      return;
    case UPDATE_PRESCRIPTION:
      draft.currentPrescription = payload;
      return;
    case ADD_PRESCRIPTION_TEMPLATE_TO_CURRENT_ORDER:
      draft.currentOrder.note = payload;
      return;
    case SET_POS_LAYOUT: {
      const newPOSLayout = {
        ...payload,
        categories: payload.categories.map(category => ({
          ...category,
          items: category.items.map(item => ({
            ...item,
            has_in_cart: false,
          })),
        })),
      };
      return void (draft.posLayout = newPOSLayout);
    }
    case SET_CURRENT_POS_CATEGORY:
      return void (draft.currentPOSCategory = payload);
    case SET_CURRENT_FOLDER: {
      return void (draft.currentPOSFolder = payload);
    }
    case UPDATE_POS_RESULTS_STATUS:
      draft.searchResults.results = draft.searchResults?.results?.map(result => {
        const hasInCart =
          draft.orderItems.findIndex(
            orderItem => orderItem?.product_id === result?.id && !result?.is_prescription && !result?.is_template
          ) !== -1;

        return {
          ...result,
          has_in_cart: hasInCart,
        };
      });
      return;
    case UPDATE_ALL_POS_LAYOUT_ITEMS_STATUS:
      draft.posLayout.categories = draft.posLayout.categories?.map(category => {
        return {
          ...category,
          items: category?.items.map(item => {
            if (item?.product?.id) {
              const hasInCart =
                draft.orderItems.findIndex(orderItem => {
                  return orderItem?.product_id === item?.product?.id;
                }) !== -1;
              return {
                ...item,
                has_in_cart: hasInCart,
              };
            }
            if (item?.folder) {
              const newFolderItems = item?.folder?.items?.map(folderItem => {
                const hasInCart =
                  draft.orderItems.findIndex(orderItem => orderItem?.product_id === folderItem?.product?.id) !== -1;

                return {
                  ...folderItem,
                  has_in_cart: hasInCart,
                };
              });
              return {
                ...item,
                folder: {
                  ...item?.folder,
                  items: newFolderItems,
                },
              };
            }
            return item;
          }),
        };
      });
      return;
    default:
      return draft;
  }
}
